import React from 'react';
import './BrandSummaryRating.css';

const BrandSummaryRating = summary => (
  <div className='summary-middle-rating-container'>
    {summary.headlines && <h5>Ratings</h5>}
    {summary.headlines && summary.headlines.map(elem => (
      <div key={elem.name} className='summary-rating-row'>
        <div className='summary-rating-column'>{elem.name}</div>
        <div className='summary-rating-column'>{elem.score}/{elem.max_score}</div>
        <div className='summary-rating-column'>{elem.label}</div>
      </div>
    ))}
  </div>
);

export default BrandSummaryRating;


// WEBPACK FOOTER //
// ./src/components/brandSummaryRating/BrandSummaryRating.js